import type { TourDefinition } from "@/types/tour";

export const dealflowListTour: TourDefinition = {
  id: "dealflow-list",
  context: "terminus-admin",
  version: 1,
  path: "/startups",
  steps: [
    {
      element: '[data-tour-id="dealflow-header"]',
      popover: {
        title: "Dealflow",
        description:
          "The startup database that powers solution matching. Browse every startup the platform has ingested and analyzed.",
      },
    },
    {
      element: '[data-tour-id="dealflow-filters"]',
      popover: {
        title: "Filter & enrich",
        description:
          "Filter by sector or one-pager status, and trigger AI enrichment on selected startups from here.",
      },
    },
  ],
};
